// Components
import DropdownInput from "components/inputs/dropdown"
// Data
import propertyReportService from "data/reports-property"
import _ from 'lodash'
import calcService from "data/calc"
import React, { FC, useState } from "react"
// Styles
import { ButtonWithPress_s, Label_s } from "styles/app-styles"
import { ReportForm_s } from "styles/report-styles"

interface TenantRosterProps {
  property: object
}

const TenantRoster: FC<TenantRosterProps> = (props) => {
  const [sort, setSort] = useState<string>("Rent Roll")

  function submit():void {
    propertyReportService.propertyReport({
      report: 'tenant_roster',
      params: {
        sort
      }
    });
  }

  const disabled = !calcService.calcCheck(props.property)
  const buttonText = disabled ? 'Calculation Required' : 'Run Report'

  return (
    <div>
      <ButtonWithPress_s primary onClick={submit} style={{marginBottom: 20}} disabled={disabled}>{buttonText}</ButtonWithPress_s>
      <ReportForm_s>
        <div>
          <Label_s>Sort Order</Label_s>
          <DropdownInput
            persist={(field:string, val:string)=>setSort(val)}
            field="sort"
            options={['Rent Roll', 'Tenant Name', 'End Date', 'Area'].map(opt => { return {label: opt, value: opt}})}
            value={sort}
          />
        </div>
      </ReportForm_s>
    </div>
  )
}

export default TenantRoster
